import { render } from "./occupy.vue?vue&type=template&id=b852d296&scoped=true"
import script from "./occupy.vue?vue&type=script&lang=js"
export * from "./occupy.vue?vue&type=script&lang=js"

import "./occupy.vue?vue&type=style&index=0&id=b852d296&lang=less&scoped=true"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b852d296"]])

export default __exports__